import {injectReducer} from "../../store/reducers";
import {forgotPasswordReducer, resetPasswordReducer} from "./modules/ForgotPassword";

export default (store) => ({
  path: 'forgot-password',
  onEnter: '',
  getComponent(nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
     and embed an async module loader (jsonp) when bundling   */
    require.ensure([], (require) => {
      /*  Webpack - use require callback to define
       dependencies for bundling   */
      // const HomeView = require('./components/HomeView').default;
      const ForgotPawword = require('./containers/ForgotPassword').default
      // /*  Add the reducer to the store on key 'counter'  */
      injectReducer(store, {key: 'otpInfo', reducer: forgotPasswordReducer})
      injectReducer(store, {key: 'resetStatus', reducer: resetPasswordReducer})

      /*  Return getComponent   */
      cb(null, ForgotPawword)

      /* Webpack named bundle   */
    }, 'forgotPassword')
  }
})



// WEBPACK FOOTER //
// ./src/routes/ForgotPassword/index.js